/**
 * A `maxDate` of this lets the calendar navigate to and select dates well beyond the
 * project's as-of date, for callers whose dates have no real ceiling — contract terms,
 * or a property filter on a datetime that may hold future timestamps.
 */
export const NO_MAX_DATE_VALUE = `unlimited`;
